import { CustomProduct } from "../../product-list-page/models/custom-product.model";

export const HOME_PAGE_FEATURE = 'home-page';

export interface homePageState {
    fetchCarouselImages: carouselState;
    fetchCategories: categoriesState;
    fetchTopFeatureProducts: topProductsState;
}

export interface carouselState {
    imageList: string[],
    activeIndex: number,
    loading: boolean,
    success: boolean,
    error: boolean
}
export interface categoriesState {
    categories: itemState[],
    loading: boolean,
    success: boolean,
    error: boolean
}

export interface topProductsState {
    products: CustomProduct[],
    loading: boolean,
    success: boolean,
    error: boolean
}

export interface itemState {
    code: string
    image: imgState
    name: string
    sequence: number
    url: string
    imgUrl: string
}
export interface imgState {
    url: string
}




